/**
 * Security Manager Feature Module
 *
 * Registers the security workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the security workspace component
registerWorkspaceComponent(
  'security',
  lazyWorkspaceTab(() => import('./components/SecurityManagerTab').then((m) => ({ default: m.SecurityManagerTab }))),
);

// Re-export components
export { SecurityManagerToolbar } from './components/SecurityManagerToolbar';
export { SecurityObjectTypeList } from './components/SecurityObjectTypeList';
export { SecurityObjectGrid } from './components/SecurityObjectGrid';
export { SecurityObjectForm } from './components/SecurityObjectForm';

// Re-export forms
export {
  LoginForm,
  UserForm,
  ServerRoleForm,
  DatabaseRoleForm,
  PgRoleForm,
  SchemaForm,
} from './components/forms';

// Re-export dialogs
export { SecurityPreviewDialog, ConfirmDeleteDialog } from './components/dialogs';

// Re-export hooks
export { useSecurityObjects } from './hooks/useSecurityObjects';
